import { KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material'
import { Box, Collapse, IconButton, TableCell, TableRow, Typography } from '@mui/material'
import { useState } from 'react'
import Helper from '../../../helpers/Helper'
import TextLink from '../TextLink'
import { Cell, Column, Row } from './SmartTableDefinitions'
import _ from 'lodash'

interface P {
    row: Row
    index: number
    item: any
    columns?: Column[]
    onClickRow?: (indexRow: number, row: Row) => void
    subContent?: JSX.Element | JSX.Element[]
}

function CollapsibleRow({ row, columns, item, index, onClickRow, subContent }: P) {
    const [open, setOpen] = useState(false)

    const renderContent = (cell: Cell, column: Column) => {
        if (cell.onClick) return <TextLink onClick={cell.onClick}>{cell.value}</TextLink>
        else if (column.customRenderer) return column.customRenderer(cell, row, item)
        else return <Typography>{_.truncate(cell.value?.toString(), { length: 50 })}</Typography>
    }

    return (
        <>
            <TableRow
                hover={Helper.hasVal(onClickRow)}
                sx={{ '& > *': { borderBottom: 'unset' }, 'cursor': onClickRow ? 'pointer' : undefined }}>
                {row.cells.map((x, i) => {
                    const column = columns?.at(i)
                    if (!column || column.hidden) return null
                    return (
                        <TableCell
                            key={i}
                            sx={{ padding: 1, borderBottom: '0px', WebkitFilter: column.blur ? 'blur(5px)' : '', userSelect: column.blur ? 'none' : '' }}
                            align={column?.numeric ? 'right' : 'left'}>
                            <Box minHeight={34} display='flex' alignItems='center' onClick={() => onClickRow && onClickRow(index, row)}>
                                {i === 0 && (
                                    <IconButton
                                        size='small'
                                        color='inherit'
                                        sx={{ marginRight: 5 }}
                                        onClick={e => {
                                            e.preventDefault()
                                            e.stopPropagation()
                                            setOpen(!open)
                                        }}>
                                        {open ? <KeyboardArrowUp color='disabled' /> : <KeyboardArrowDown color='disabled' />}
                                    </IconButton>
                                )}
                                {renderContent(x, column)}
                            </Box>
                        </TableCell>
                    )
                })}
            </TableRow>
            <TableRow>
                <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={row.cells.length + 1}>
                    <Collapse in={open} timeout='auto' unmountOnExit>
                        {subContent}
                    </Collapse>
                </TableCell>
            </TableRow>
        </>
    )
}

export default CollapsibleRow
